// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { assignVehicleToDriver } from '../../services/VehiclesService';
import { AssignVehicleToDriverRequest, Vehicle } from '../../types/Vehicles';

type Result = UseMutationResult<Vehicle, Error, AssignVehicleToDriverRequest>;

function useAssignVehicleToDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(assignVehicleToDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
      queryClient.invalidateQueries({ queryKey: ['driver'] });
      queryClient.invalidateQueries({ queryKey: ['vehicles'] });
      queryClient.invalidateQueries({ queryKey: ['vehicle'] });
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
      queryClient.invalidateQueries({ queryKey: ['driver-score-years-computed'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAssignVehicleToDriver;
